import { GlobalState } from '@leverege/ui-redux';
import { Types } from "../../constants/index.js";
import SubField from "../builders/SubField.js";
export default SubField({
  objectType: Types.deviceType,
  baseAttrName: 'options',
  baseAttrField: 'options',
  field: 'imagine/groupBlueprintId',
  creatable: true,
  editable: true,
  displayName: 'Group Blueprint Id',
  valueType: 'string',
  createOptions: {
    editor: 'enum',
    editorProps: {
      get values() {
        return GlobalState.get()?.blueprints?.[window.Molten?.config?.api?.projectId]?.blueprints;
      },
      valueKey: 'id'
    }
  }
});